export default __webpack_public_path__ + "static/media/Manage_users_icon_white.c36b4be2.svg";